// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@hardwoods/XDL/types";

export default {
    primary: {
        main: "#0068B3",
        contrast: "#FFFFFF",
        hover: "#00548C",
        dark: "#042E45",
    },
    secondary: {
        main: "#E07C40",
        contrast: "#FFFFFF",
        hover: "#AE531C",
        dark: "#5F2C0D",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        border: "#CCCCCC",
        disabled: "#CCCCCC",
        brand1: "#003F6C",
        brand2: "#65B2E9",
        brand3: "#98CAEC",
        brand4: "#B9D9EC",
        secondary2: "#AA6E5D",
        ui1: "#EBE9E1",
        ui2: "#D1CDC2",
        ui3: "#F3F3F3",
        ui4: "#FAFAFA",
        ui10: "#EEEEEE",
        ui11: "#CCCCCC",
        ui12: "#999999",
        ui13: "#666666",
        ui14: "#333333",
        white: "#FFFFFF",
        gray: "#999999",
        black: "#000000",
    },
    text: {
        main: "#434343",
        secondary: "#757575",
        inverse: "#FFFFFF",
        disabled: "#475353",
        accent: "#2D3435",
        link: "#0068B3",
    },
    success: {
        main: "#00A65A",
        contrast: "#FFFFFF",
        background: "#EEFFF3",
    },
    danger: {
        main: "#E4104E",
        contrast: "#FFFFFF",
        dark: "#D01C1C",
        background: "#FFF0F0",
    },
    warning: {
        main: "#F1D622",
        contrast: "#FFFFFF",
        background: "#FFF5E0",
    },
    info: {
        main: "#53ACDB",
        contrast: "#FFFFFF",
        background: "#F1FDFF",
    },
} as xBaseTheme["colors"];
